import { Stack, Text } from "@chakra-ui/react";

import FormReferido from "@/components/referidos/FormReferido";

const Contact = ({ optionsDevelops }) => {
    return (
        <Stack maxW="3xl" px={{ base: 10, md: 0 }}>
            <Text fontSize="2xl" fontWeight="bold" color="#002B49" textAlign="center" mb={5}>
                Contacto
            </Text>
            <FormReferido
                onClose={() => {}}
                onOpen={() => {}}
                setTitle={() => {}}
                setMessage={() => {}}
                setStatus={() => {}}
                optionsDevelops={optionsDevelops}
            />
        </Stack>
    );
};

export default Contact;
